import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AcontoClientView, Faktura } from '@store/models';
import { AlertService } from 'app/core/alerts/alert.service';
import { ConfirmService } from 'app/shared/confirm-dialog/confirm-dialog.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FakturaService } from '../services/faktura.service';

@Component({
    selector: 'app-interim-invoicing-modal',
    templateUrl: './interim-invoicing-modal.component.html',
    styleUrls: ['./interim-invoicing-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InterimInvoicingModalComponent {
    acontoClients$: Observable<AcontoClientView[]>;
    acontoDate: Date;
    acontoType = -1;

    constructor(
        private fakturaService: FakturaService,
        private activeModal: NgbActiveModal,
        private alert: AlertService,
        private confirm: ConfirmService,
        private cdRef: ChangeDetectorRef
    ) { }

    onAcontoDate(acontoDate: string) {
        this.acontoDate = new Date(acontoDate + 'Z');
        this.loadAcontoClients();
    }

    onAcontoType(acontoType: number) {
        this.acontoType = acontoType;
        if (!this.acontoDate) { return; }
        this.loadAcontoClients();
    }

    async acontoBulk(bulkCount: number) {
        if (bulkCount < 1) {
            this.alert.createAlert('Der er ingen manglende fakturaer indenfor de valgte kriterier!', 'info');
            return;
        }
        const confirmBulk = await this.confirm.question(
            `Dette vil oprette ${bulkCount} nye fakturaer`,
            'Lav fakturaer',
            'Annuller'
        );
        if (!confirmBulk) { return; }
        this.fakturaService.acontoBulk(this.acontoDate, this.acontoType).pipe(
            tap(fakturaer => this.acontoBulkReturned(fakturaer))
        ).subscribe();
    }

    private acontoBulkReturned(fakturaer: Faktura[]) {
        this.alert.createAlert(`Der blev oprettet ${fakturaer.length} nye fakturaer`, 'success');
        this.loadAcontoClients();
        this.cdRef.detectChanges();
    }

    private loadAcontoClients() {
        this.acontoClients$ = this.fakturaService.acontoClients(this.acontoDate, this.acontoType);
    }

    onDismiss() {
        this.activeModal.dismiss();
    }
}
